import { Loader2 } from "@/components/icons"
import { Card, CardContent } from "@/components/ui/card"
import { DownloadButton } from "@/features/file-viewer/components/download-button"
import { cn } from "@/lib/utils"

import { renderFileIcon } from "./file-picker/utils"

type AttachmentCardProps = {
  sessionId: string
  filename: string
  className?: string
  pending?: boolean
}

export function AttachmentCard({ sessionId, filename, className, pending }: AttachmentCardProps) {
  const fileUrl = `/api/session-content/${sessionId}/${encodeURIComponent(filename)}`

  return (
    <Card className={cn("flex items-center justify-between gap-3 p-3", className)}>
      <CardContent className="flex w-full items-center justify-between gap-3 p-0">
        <section className="flex min-w-0 items-center gap-2">
          <span className="shrink-0">{renderFileIcon(filename)}</span>
          <span className="truncate text-sm" title={filename}>
            {filename}
          </span>
        </section>
        {pending ? (
          <Loader2 className="text-muted-foreground size-5 shrink-0 animate-spin" />
        ) : (
          <DownloadButton fileUrl={fileUrl} title={filename} />
        )}
      </CardContent>
    </Card>
  )
}
